import React, { useEffect } from "react"
import Prism from "prismjs"
import '../style/prism.css'

import style from "./style/codeblock.module.css"

// plugins
require('../../node_modules/prismjs/plugins/line-numbers/prism-line-numbers.min.js');
require('../../node_modules/prismjs/plugins/command-line/prism-command-line.min');

// languages
require('../../node_modules/prismjs/components/prism-bash.min.js');

let _promptState = {
    user: 'user',
    host: 'host',
}

export const setDefaultPrompt = (user, host) => {
    _promptState.user = user;
    _promptState.host = host;
}

const outputDelimiter = RegExp('^> ');

export default (props) => {

    const inputCode = props.code;

    useEffect(() => {
        Prism.highlightAll();
    })

    const code = (() => {
        const stripped = props.nostrip ? inputCode : inputCode.replace(/^( |\t)*\n*/, '');

        let outLines = '';

        let outCode = stripped;

        // hand rolled data-output-filter from prism command line plugin
        if (props.commandline) {
            let lines = new Array();
            let i = 0, j = 0, line=1;
            while ( j < stripped.length) {
                if (stripped.charAt(j) === '\n') {
                    if (stripped.slice(i,j).match(outputDelimiter)) {
                        outLines += `${line},`
                        lines.push(stripped.slice(i,j).replace(outputDelimiter,''));
                    } else if (i === j && stripped.charAt(i) === '\n') {
                        lines.push(' ');
                    }
                    else {
                        lines.push(stripped.slice(i,j));
                    }
                    j++;
                    i = j;
                    line++;
                }
                j++;
            }

            if (i != j) {
                lines.push(stripped.slice(i,j));
            }

            outCode = lines.join('\n');
        }

        return {
            code: outCode,
            outputLines: outLines,
        }
    })()

    const filepath = props.filepath 
        ? (!props.commandline)
            ? <p style={{color: "#999", fontSize: "0.8em", float: "right"}}>{props.filepath}</p>
            : <p style={{color: "#999", fontSize: "0.8em", float: "right"}}>shell</p>
        : null;

    return (
        <div>
            <pre 
            className={`
                ${!props.nolinenumbers && !props.commandline ? 'line-numbers ' : null} 
                ${props.commandline ? 'command-line ' : null} 
                ${'language-' + props.language}
            `}
            data-user={_promptState.user} data-host={_promptState.host}
            data-output={props.commandline ? code.outputLines : ''}
            >
            {filepath}
                <code className={`${'language-' + props.language}`}>
                    {code.code}
                </code>
            </pre>
        </div>
    )
}